import { NextRouter } from 'next/router';

interface FooterCheckOptions {
  isSolePage: boolean;
  courses_slug?: string | null;
  showFooter?: boolean;
  bookId?: string | null;
  productId?: string | null;
}

export const shouldShowFooter = (
  router: NextRouter,
  {
    isSolePage,
    courses_slug,
    showFooter,
    bookId,
    productId,
  }: FooterCheckOptions,
): boolean => {
  if (!router.isReady || isSolePage) return false;

  const { pathname } = router;

  const excludedPaths: string[] = [
    '/cart',
    '/checkout',
    '/checkout-v2',
    '/checkout/upgrad-to-hardcopy',
    '/checkout/upgrade-to-hardcopy',
    '/broadcast-message',
    '/personality_test',
    '/onboarding',
    '/policies',
    '/zai',
    '/plans/platform-checkout',
    '/plans/byob-checkout',
  ];

  const isExcluded =
    excludedPaths.includes(pathname) ||
    pathname.includes('watch') ||
    pathname.includes('/pdf') ||
    pathname.includes('/course/');

  return !isExcluded && !courses_slug && !!showFooter && !(bookId && productId);
};
